interface FormFieldEntry {
  label: string;
  value: string;
}

/**
 * @description Extracts current values from MUI FormControl and Autocomplete
 * components present in the DOM.
 *
 * @returns: Array of "Label:Value" formatted strings
 */
export function buildFormSection(): readonly string[] {
  console.trace('TRACE');
  const formContainers = document.querySelectorAll<HTMLElement>(
    '.MuiFormControl-root, .MuiAutocomplete-root'
  );

  const fieldEntries: FormFieldEntry[] = [];
  formContainers.forEach((container) => {
    const chipElements = container.querySelectorAll<HTMLElement>('.MuiChip-root .MuiChip-label');

    if (chipElements.length > 0) {
      const labelElement = container.querySelector<HTMLElement>(
        'label.MuiInputLabel-root, .MuiFormLabel-root'
      );
      const fieldLabel = labelElement?.textContent?.replace('*', '').trim() || 'campo';

      const chipValues = Array.from(chipElements)
        .map((chip) => chip.textContent?.trim())
        .filter(Boolean)
        .join(', ');

      if (chipValues) {
        fieldEntries.push({ label: fieldLabel, value: chipValues });
      }
    }

    const inputElement = container.querySelector<HTMLInputElement>(
      'input.MuiInputBase-input, .MuiAutocomplete-input'
    );

    if (inputElement && inputElement.type !== 'password') {
      const fieldValue = inputElement.value?.trim();

      if (fieldValue) {
        const fieldLabel = extractFieldLabel(container, inputElement);
        fieldEntries.push({ label: fieldLabel, value: fieldValue });
      }
    }
  });

  return fieldEntries.map((entry) => `${entry.label}:${entry.value}`);
}
/**
 * @description Resolves human-readable label for a form field container.
 *
 * @returns Label string
 */
function extractFieldLabel(container: HTMLElement, inputElement: HTMLInputElement): string {
  const labelElement = container.querySelector<HTMLElement>(
    'label.MuiInputLabel-root, .MuiFormLabel-root'
  );

  return (
    labelElement?.textContent?.replace('*', '').trim() ||
    inputElement.placeholder ||
    inputElement.name ||
    'campo'
  );
}
